'use client';
import { AppKit } from '@web3modal/base';
import { EVMEthersClient } from '@web3modal/base/adapters/evm/ethers';
import { ConstantsUtil } from '@web3modal/scaffold-utils';
import { EthersStoreUtil } from '@web3modal/scaffold-utils/ethers';
import { getWeb3Modal } from '@web3modal/base/utils/library/react';
import { useSnapshot } from 'valtio';
export { defaultConfig } from '@web3modal/base/adapters/evm/ethers';
let appkit = undefined;
let ethersAdapter = undefined;
export function createWeb3Modal(options) {
    ethersAdapter = new EVMEthersClient({
        ethersConfig: options.ethersConfig,
        siweConfig: options.siweConfig,
        chains: options.chains,
        defaultChain: options.defaultChain
    });
    appkit = new AppKit({
        ...options,
        defaultChain: ethersAdapter.defaultChain,
        adapters: [ethersAdapter],
        sdkType: 'w3m',
        sdkVersion: `react-ethers-${ConstantsUtil.VERSION}`
    });
    getWeb3Modal(appkit);
    return appkit;
}
export function useWeb3ModalProvider() {
    const { provider, providerType } = useSnapshot(EthersStoreUtil.state);
    const walletProvider = provider;
    const walletProviderType = providerType;
    return {
        walletProvider,
        walletProviderType
    };
}
export function useDisconnect() {
    async function disconnect() {
        await ethersAdapter?.disconnect();
    }
    return {
        disconnect
    };
}
export function useSwitchNetwork() {
    async function switchNetwork(chainId) {
        await ethersAdapter?.switchNetwork(chainId);
    }
    return {
        switchNetwork
    };
}
export function useWeb3ModalAccount() {
    const { address, isConnected, chainId, status } = useSnapshot(EthersStoreUtil.state);
    return {
        address,
        isConnected,
        chainId,
        status
    };
}
export function useWeb3ModalError() {
    const { error } = useSnapshot(EthersStoreUtil.state);
    return {
        error
    };
}
export { useWeb3ModalTheme, useWeb3Modal, useWeb3ModalState, useWeb3ModalEvents, useWalletInfo } from '@web3modal/base/utils/library/react';
//# sourceMappingURL=react.js.map